<div class="grid" >
  <div class="col-12">
    <div class="card">
      <ng-container *ngIf="!this.isAccountLoading">
        <form *ngIf="userForm" [formGroup]="userForm">
          <div class="grid">
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label for="firstName">{{'attribute.firstName' | transloco}}: (*)</label>
              </div>
              <div class="col-12">
                <input class="w-full" formControlName="firstName" id="firstName" pInputText type="text">
              </div>
              <app-validation-errors [control]="userForm.get('firstName')"></app-validation-errors>
            </div>
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label for="lastName">{{'attribute.lastName' | transloco}}: (*)</label>
              </div>
              <div class="col-12">
                <input class="w-full" formControlName="lastName" id="lastName" pInputText type="text">
              </div>
              <app-validation-errors [control]="userForm.get('lastName')"></app-validation-errors>
            </div>
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label for="username">{{'attribute.username' | transloco}}: (*)</label>
              </div>
              <div class="col-12">
                <input class="w-full" formControlName="username" id="username" pInputText type="text">
              </div>
              <app-validation-errors [control]="userForm.get('username')"></app-validation-errors>
            </div>
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label for="email">{{'attribute.email' | transloco}}: (*)</label>
              </div>
              <div class="col-12">
                <input class="w-full" formControlName="email" id="email" pInputText type="text">
              </div>
              <app-validation-errors [control]="userForm.get('email')"></app-validation-errors>
            </div>
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label for="phone">{{'attribute.phone' | transloco}}: (*)</label>
              </div>
              <div class="col-12">
                <ngx-intl-tel-input
                  [cssClass]="'w-full'"
                  [preferredCountries]="preferredCountries"
                  [enableAutoCountrySelect]="true"
                  [enablePlaceholder]="true"
                  [searchCountryPlaceholder]="'search.byCountry' | transloco"
                  [searchCountryFlag]="true"
                  [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
                  [selectFirstCountry]="false"
                  [separateDialCode]="true"
                  [maxLength]="15"
                  [phoneValidation]="true"
                  [inputId]="'phone'"
                  [numberFormat]="PhoneNumberFormat.International"
                  formControlName="phone"
                  id="phone"
                ></ngx-intl-tel-input>
              </div>
            </div>
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label for="profile">{{'model.profile' | transloco}}: (*)</label>
              </div>
              <div class="col-12">
                <input class="w-full" formControlName="profile" id="profile" pInputText type="text">
              </div>
              <app-validation-errors [control]="userForm.get('profile')"></app-validation-errors>
            </div>
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label>{{'attribute.language' | transloco}}: (*)</label>
              </div>
              <div class="col-12">
                <p-dropdown
                  [options]="languageOptions"
                  [(ngModel)]="selectedLanguage"
                  [ngModelOptions]="{standalone: true}"
                  optionLabel="name"
                  filterBy="name"
                  styleClass="w-full dropdown-language"
                >
                  <ng-template pTemplate="selectedItem">
                    <div class="flex align-items-center">
                      <i [class]="'flag-icon flag-icon-' + selectedLanguage.code"></i>
                      <p class="mb-0 ml-1 mt-1 p-0">{{selectedLanguage.name}}</p>
                    </div>
                  </ng-template>
                  <ng-template let-language pTemplate="item">
                    <div class="flex align-items-center">
                      <i [class]="'flag-icon flag-icon-' + language.code"></i>
                      <p class="mb-0 ml-1 mt-1 p-0">{{language.name}}</p>
                    </div>
                  </ng-template>
                </p-dropdown>
              </div>
            </div>
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label for="timeZone">{{'attribute.timezone' | transloco}}: (*)</label>
              </div>
              <div class="col-12">
                <p-dropdown
                  [placeholder]="'select.timezone' | transloco"
                  [options]="timeZoneOptions"
                  [filter]="true"
                  styleClass="w-full"
                  id="timeZone"
                  optionValue="name"
                  optionLabel="name"
                  formControlName="timeZone"
                ></p-dropdown>
              </div>
              <app-validation-errors [control]="userForm.get('timeZone')"></app-validation-errors>
            </div>
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label for="eCommerceUser">{{'attribute.eCommerceUser' | transloco}}:</label>
              </div>
              <div class="col-12">
                <p-checkbox id="eCommerceUser" formControlName="eCommerceUser" binary="true" class="w-full" [disabled]="true"></p-checkbox>
              </div>
            </div>
          </div>
          <hr style="border-color: #eceeec; width: 65%;" class="mx-auto">
          <div class="grid">
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label for="organization">{{'model.organization' | transloco}}: </label>
              </div>
              <div class="col-12">
                <input class="w-full" formControlName="organization" id="organization" pInputText type="text">
              </div>
            </div>
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label for="orgCode">{{'attribute.orgCode' | transloco}}: </label>
              </div>
              <div class="col-12">
                <input class="w-full" formControlName="orgCode" id="orgCode" pInputText type="text">
              </div>
            </div>
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label for="organizationType">{{'attribute.organizationType' | transloco}}: </label>
              </div>
              <div class="col-12">
                <input class="w-full" formControlName="organizationType" id="organizationType" pInputText type="text">
              </div>
            </div>
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label for="organizationParent">{{'attribute.organizationParent' | transloco}}: </label>
              </div>
              <div class="col-12">
                <input class="w-full" formControlName="organizationParent" id="organizationParent" pInputText type="text">
              </div>
            </div>
          </div>
          <hr style="border-color: #eceeec; width: 65%;" class="mx-auto">
          <div class="grid">
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label for="password">{{'attribute.password' | transloco}}: </label>
              </div>
              <div class="col-12">
                <p-password
                  [toggleMask]="true"
                  (change)="newPasswordCheck()"
                  styleClass="p-password p-component p-input-icon-right w-full-password"
                  class="w-full"
                  id="password"
                  formControlName="password"
                ></p-password>
              </div>
            </div>
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label for="confirmPassword">{{'attribute.repeatPassword' | transloco}}: </label>
              </div>
              <div class="col-12">
                <p-password
                  [toggleMask]="true"
                  (change)="newPasswordCheck()"
                  styleClass="p-password p-component p-input-icon-right w-full-password"
                  class="w-full"
                  id="confirmPassword"
                  formControlName="confirmPassword"
                ></p-password>
              </div>
            </div>
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label>&nbsp;</label>
              </div>
              <div class="col-12">
                <button
                  [label]="'common.generatePassword' | transloco"
                  (click)="generatePassword()"
                  pButton
                  class="p-button-secondary"
                  icon="pi pi-key"
                ></button>
              </div>
            </div>
          </div>
          <hr *ngIf="authGuard.hasPermission(this.PERMISSION_MANAGE_ALARM_SUBSCRIPTIONS)" style="border-color: #eceeec; width: 65%;" class="mx-auto">
          <div *ngIf="authGuard.hasPermission(this.PERMISSION_MANAGE_ALARM_SUBSCRIPTIONS)" class="grid">
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label>{{'attribute.mailLanguage' | transloco}}: (*)</label>
              </div>
              <div class="col-12">
                <p-dropdown
                  [options]="languageOptions"
                  [(ngModel)]="selectedMailLanguage"
                  [ngModelOptions]="{standalone: true}"
                  optionLabel="name"
                  filterBy="name"
                  styleClass="w-full dropdown-language"
                >
                  <ng-template pTemplate="selectedItem">
                    <div class="flex align-items-center">
                      <i [class]="'flag-icon flag-icon-' + selectedMailLanguage.code"></i>
                      <p class="mb-0 ml-1 mt-1 p-0">{{selectedMailLanguage.name}}</p>
                    </div>
                  </ng-template>
                  <ng-template let-language pTemplate="item">
                    <div class="flex align-items-center">
                      <i [class]="'flag-icon flag-icon-' + language.code"></i>
                      <p class="mb-0 ml-1 mt-1 p-0">{{language.name}}</p>
                    </div>
                  </ng-template>
                </p-dropdown>
              </div>
            </div>
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label for="mailTimezone">{{'attribute.mailTimezone' | transloco}}: (*)</label>
              </div>
              <div class="col-12">
                <p-dropdown
                  [placeholder]="'select.timezone' | transloco"
                  [options]="timeZoneOptions"
                  [filter]="true"
                  styleClass="w-full"
                  id="mailTimezone"
                  optionValue="name"
                  optionLabel="name"
                  formControlName="mailTimezone"></p-dropdown>
              </div>
            </div>
          </div>
          <div *ngIf="authGuard.hasPermission(this.PERMISSION_MANAGE_ALARM_SUBSCRIPTIONS)" class="grid mt-1">
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label>{{'attribute.alarmSubscriptions' | transloco}}: </label>
              </div>
            </div>
          </div>
        </form>
      </ng-container>
      <ng-container *ngIf="this.isAccountLoading">
        <div class="grid">
          <div class="col-12 md:col-12 lg:col-6 xl:col-4">
            <div class="form-field col-12">
              <label for="firstName">{{'attribute.firstName' | transloco}}: (*)</label>
            </div>
            <div class="col-12">
              <p-skeleton width="100%" height="2.5rem"></p-skeleton>
            </div>
          </div>
          <div class="col-12 md:col-12 lg:col-6 xl:col-4">
            <div class="form-field col-12">
              <label for="lastName">{{'attribute.lastName' | transloco}}: (*)</label>
            </div>
            <div class="col-12">
              <p-skeleton width="100%" height="2.5rem"></p-skeleton>
            </div>
          </div>
          <div class="col-12 md:col-12 lg:col-6 xl:col-4">
            <div class="form-field col-12">
              <label for="username">{{'attribute.username' | transloco}}: (*)</label>
            </div>
            <div class="col-12">
              <p-skeleton width="100%" height="2.5rem"></p-skeleton>
            </div>
          </div>
          <div class="col-12 md:col-12 lg:col-6 xl:col-4">
            <div class="form-field col-12">
              <label for="email">{{'attribute.email' | transloco}}: (*)</label>
            </div>
            <div class="col-12">
              <p-skeleton width="100%" height="2.5rem"></p-skeleton>
            </div>
          </div>
          <div class="col-12 md:col-12 lg:col-6 xl:col-4">
            <div class="form-field col-12">
              <label for="phone">{{'attribute.phone' | transloco}}: (*)</label>
            </div>
            <div class="col-12">
              <p-skeleton width="100%" height="2.5rem"></p-skeleton>
            </div>
          </div>
          <div class="col-12 md:col-12 lg:col-6 xl:col-4">
            <div class="form-field col-12">
              <label for="profile">{{'model.profile' | transloco}}: (*)</label>
            </div>
            <div class="col-12">
              <p-skeleton width="100%" height="2.5rem"></p-skeleton>
            </div>
          </div>
          <div class="col-12 md:col-12 lg:col-6 xl:col-4">
            <div class="form-field col-12">
              <label>{{'attribute.language' | transloco}}: (*)</label>
            </div>
            <div class="col-12">
              <p-skeleton width="100%" height="2.5rem"></p-skeleton>
            </div>
          </div>
          <div class="col-12 md:col-12 lg:col-6 xl:col-4">
            <div class="form-field col-12">
              <label for="timeZone">{{'attribute.timezone' | transloco}}: (*)</label>
            </div>
            <div class="col-12">
              <p-skeleton width="100%" height="2.5rem"></p-skeleton>
            </div>
          </div>
          <div class="col-12 md:col-12 lg:col-6 xl:col-4">
            <div class="form-field col-12">
              <label for="eCommerceUser">{{'attribute.eCommerceUser' | transloco}}: (*)</label>
            </div>
            <div class="col-12">
              <p-skeleton width="1.5rem" height="1.5rem"></p-skeleton>
            </div>
          </div>
        </div>
        <hr style="border-color: #eceeec; width: 65%;" class="mx-auto">
        <div class="grid">
          <div class="col-12 md:col-12 lg:col-6 xl:col-4">
            <div class="form-field col-12">
              <label for="organization">{{'model.organization' | transloco}}: </label>
            </div>
            <div class="col-12">
              <p-skeleton width="100%" height="2.5rem"></p-skeleton>
            </div>
          </div>
          <div class="col-12 md:col-12 lg:col-6 xl:col-4">
            <div class="form-field col-12">
              <label for="organizationType">{{'attribute.organizationType' | transloco}}: </label>
            </div>
            <div class="col-12">
              <p-skeleton width="100%" height="2.5rem"></p-skeleton>
            </div>
          </div>
          <div class="col-12 md:col-12 lg:col-6 xl:col-4">
            <div class="form-field col-12">
              <label for="organizationParent">{{'attribute.organizationParent' | transloco}}: </label>
            </div>
            <div class="col-12">
              <p-skeleton width="100%" height="2.5rem"></p-skeleton>
            </div>
          </div>
        </div>
        <hr style="border-color: #eceeec; width: 65%;" class="mx-auto">
        <div class="grid">
          <div class="col-12 md:col-12 lg:col-6 xl:col-4">
            <div class="form-field col-12">
              <label for="password">{{'attribute.password' | transloco}}: </label>
            </div>
            <div class="col-12">
              <p-skeleton width="100%" height="2.5rem"></p-skeleton>
            </div>
          </div>
          <div class="col-12 md:col-12 lg:col-6 xl:col-4">
            <div class="form-field col-12">
              <label for="confirmPassword">{{'attribute.repeatPassword' | transloco}}: </label>
            </div>
            <div class="col-12">
              <p-skeleton width="100%" height="2.5rem"></p-skeleton>
            </div>
          </div>
          <div class="col-12 md:col-12 lg:col-6 xl:col-4">
            <div class="form-field col-12">
              <label>&nbsp;</label>
            </div>
            <div class="col-12">
              <div class="w-15rem">
                <p-skeleton width="100%" height="2.5rem"></p-skeleton>
              </div>
            </div>
          </div>
        </div>
        <hr *ngIf="authGuard.hasPermission(this.PERMISSION_MANAGE_ALARM_SUBSCRIPTIONS)" style="border-color: #eceeec; width: 65%;" class="mx-auto">
        <div *ngIf="authGuard.hasPermission(this.PERMISSION_MANAGE_ALARM_SUBSCRIPTIONS)" class="grid">
          <div class="col-12 md:col-12 lg:col-6 xl:col-4">
            <div class="form-field col-12">
              <label>{{'attribute.mailLanguage' | transloco}}: (*)</label>
            </div>
            <div class="col-12">
              <p-skeleton width="100%" height="2.5rem"></p-skeleton>
            </div>
          </div>
          <div class="col-12 md:col-12 lg:col-6 xl:col-4">
            <div class="form-field col-12">
              <label>{{'attribute.mailTimezone' | transloco}}: (*)</label>
            </div>
            <div class="col-12">
              <p-skeleton width="100%" height="2.5rem"></p-skeleton>
            </div>
          </div>
        </div>
        <div *ngIf="authGuard.hasPermission(this.PERMISSION_MANAGE_ALARM_SUBSCRIPTIONS)" class="grid mt-1">
          <div class="col-12 md:col-12 lg:col-6 xl:col-4">
            <div class="form-field col-12">
              <label>{{'attribute.alarmSubscriptions' | transloco}}: </label>
            </div>
          </div>
        </div>
      </ng-container>

      <div class="col-12 md:col-12" *ngIf="authGuard.hasPermission(this.PERMISSION_MANAGE_ALARM_SUBSCRIPTIONS)">
        <div class="p-datatable p-component p-datatable-hoverable-rows mt-2">
          <p-table dataKey="alarmDefinitionUuid" [(first)]="first" [(rows)]="rows" [paginator]="true"
                   [responsive]="true" [rowsPerPageOptions]="[10,25,50]" [value]="userSubscriptions"
                   styleClass="p-datatable-striped" [breakpoint]="'1200px'">
            <ng-template pTemplate="header">
              <tr>
                <th scope="col">
                  {{'attribute.name' | transloco}}
                </th>
                <th scope="col">
                  {{'attribute.sensor' | transloco}}
                </th>
                <th scope="col">
                  {{'attribute.condition' | transloco}}
                </th>
                <th scope="col">
                  {{'attribute.timer' | transloco}}
                </th>
                <th scope="col">
                  {{'attribute.organizationOwner' | transloco}}
                </th>
                <th scope="col">
                  {{'attribute.notificationType' | transloco}}
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-alarm>
              <tr *ngIf="!this.subscriptionsLoading">
                <td>
                  <span class="p-column-title bold">{{'attribute.name' | transloco}}</span>
                  {{alarm.alarmDefinitionName}}
                </td>
                <td>
                  <span class="p-column-title bold">{{'attribute.sensor' | transloco}}</span>
                  {{alarm.deviceMeasurement}}
                </td>
                <td>
                  <span class="p-column-title bold">{{'attribute.condition' | transloco}}</span>
                  {{this.operationsTranslation[alarm.operation]}} ({{ alarm.value}})
                </td>
                <td>
                  <span class="p-column-title bold">{{'attribute.timer' | transloco}}</span>
                  {{alarm.timeWindow}}
                </td>
                <td>
                  <span class="p-column-title bold">{{'attribute.organizationOwner' | transloco}}</span>
                  {{alarm.organizationOwner.name}} ({{alarm.organizationOwner.orgCode}})
                </td>
                <td>
                  <span class="p-column-title bold">{{'attribute.notificationType' | transloco}}</span>
                  <button *ngIf="alarm.alarmNotificationType == null" class="display-no-notificate white-space-nowrap"
                          pButton type="button" icon="pi pi-times" iconPos="left"
                          [label]="this.notificationTypeTranslation['NONE']"
                          (click)="this.changeNotificationType(alarm)"></button>
                  <button *ngIf="alarm.alarmNotificationType === AlarmNotificationType.INSTANTANEOUS"
                          class="display-notificate white-space-nowrap" pButton type="button" icon="pi pi-send" iconPos="left"
                          [label]="this.notificationTypeTranslation[AlarmNotificationType.INSTANTANEOUS]"
                          (click)="this.changeNotificationType(alarm)"></button>
                  <button *ngIf="alarm.alarmNotificationType === AlarmNotificationType.AGGREGATED"
                          class="display-notificate white-space-nowrap" pButton type="button" icon="pi pi-clock"
                          iconPos="left" [label]="this.notificationTypeTranslation[AlarmNotificationType.AGGREGATED]"
                          (click)="this.changeNotificationType(alarm)"></button>
                </td>
              </tr>
              <tr *ngIf="this.subscriptionsLoading">
                <td class="row-height">
                  <p-skeleton height="1em"></p-skeleton>
                </td>
                <td class="row-height">
                  <p-skeleton height="1em"></p-skeleton>
                </td>
                <td class="row-height">
                  <p-skeleton height="1em"></p-skeleton>
                </td>
                <td class="row-height">
                  <p-skeleton height="1em"></p-skeleton>
                </td>
                <td class="row-height">
                  <p-skeleton height="1em"></p-skeleton>
                </td>
                <td class="row-height">
                  <p-skeleton height="1em"></p-skeleton>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="summary">
              <div class="flex align-items-center justify-content-between"
                   *ngIf="this.totalUserSubscriptions == 0">
                {{'pagination.empty'
                | transloco}}</div>
              <div class="flex align-items-center justify-content-between"
                   *ngIf="this.totalUserSubscriptions > 0">
                {{'pagination.showing' | transloco}} {{first + 1}}
                {{'pagination.to' | transloco}} {{(first + rows) >= this.totalUserSubscriptions ?
                this.totalUserSubscriptions : (first +
                  rows)}}
                {{'pagination.of' | transloco}} {{this.totalUserSubscriptions}}
                {{(this.totalUserSubscriptions > 1 ? 'pagination.entries' : 'pagination.entry') |
                transloco}}
              </div>
            </ng-template>
          </p-table>
        </div>
      </div>

      <ng-container *ngIf="!this.isAccountLoading &&
      (!authGuard.hasPermission(this.PERMISSION_MANAGE_ALARM_SUBSCRIPTIONS) || !this.subscriptionsLoading)">
        <div class="grid">
          <div class="col-12">
            <div class="mt-auto col-12">
              <div class="flex justify-content-end mt-4">
                <p-button
                  [label]="'common.save' | transloco"
                  [disabled]="!userForm?.valid"
                  [loading]="persistingChanges"
                  (onClick)="persistUserData()"
                  styleClass="p-button-primary"
                ></p-button>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="this.isAccountLoading ||
      (authGuard.hasPermission(this.PERMISSION_MANAGE_ALARM_SUBSCRIPTIONS) && this.subscriptionsLoading)">
        <div class="grid">
          <div class="col-12">
            <div class="mt-auto col-12">
              <div class="flex justify-content-end mt-4">
                <div class="w-6rem">
                  <p-skeleton width="100%" height="2.5rem"></p-skeleton>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>

    </div>
  </div>
</div>
